import { render, staticRenderFns } from "./list-weight.vue?vue&type=template&id=41c86bfb&scoped=true&"
import script from "./list-weight.vue?vue&type=script&lang=ts&"
export * from "./list-weight.vue?vue&type=script&lang=ts&"
import style0 from "./list-weight.vue?vue&type=style&index=0&id=41c86bfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c86bfb",
  null
  
)

export default component.exports